import { forEach } from 'ramda';
import { useMemo } from 'react';
import { bi } from '../../../services/loggers/bi';
import { extractCommonBiFieldsFromItems, extractItemsBatchParams } from '../../bi';
import { MediaManagerSDKAnyItem } from '../../media-manager-sdk';
import { useFileType } from './useFileType';
import { mediaManagerTrashActions } from '@wix/bi-logger-media-manager-g6/v2';
import { BIPageName } from '../../../constants/Bi';

export enum Actions {
  MoveToTrash = 'added_to_trash',
  Restored = 'restored',
  DeleteForever = 'delete_forever',
  EmptyTrash = 'empty_trash',
}

export enum ClickOrigin {
  MoreInfo = 'more_info',
  TopBar = 'top_bar',
  RightClick = 'right_click',
  Notifications = 'notifications',
  DragDrop = 'drag_drop',
}

export interface IParams {
  clickOrigin: ClickOrigin;
}

export const useTrackTrashActions = () => {
  const fileType = useFileType();

  return useMemo(
    () => ({
      trackMoveToTrash: (items: MediaManagerSDKAnyItem[], params: IParams) => {
        forEach<MediaManagerSDKAnyItem, MediaManagerSDKAnyItem[]>((item) => {
          bi.logger().report(
            mediaManagerTrashActions({
              pageName: BIPageName.MediaManager,
              target: Actions.MoveToTrash,
              ...extractItemsBatchParams(items),
              ...extractCommonBiFieldsFromItems(item, { fileType }),
              ...params,
            }),
          );
        }, items);
      },
      trackRestore: (items: MediaManagerSDKAnyItem[], params: IParams) => {
        forEach<MediaManagerSDKAnyItem, MediaManagerSDKAnyItem[]>((item) => {
          bi.logger().report(
            mediaManagerTrashActions({
              pageName: BIPageName.MediaManager,
              target: Actions.Restored,
              ...extractItemsBatchParams(items),
              ...extractCommonBiFieldsFromItems(item, { fileType }),
              ...params,
            }),
          );
        }, items);
      },
      trackDeletedForever: (items: MediaManagerSDKAnyItem[], params: IParams) => {
        forEach<MediaManagerSDKAnyItem, MediaManagerSDKAnyItem[]>((item) => {
          bi.logger().report(
            mediaManagerTrashActions({
              pageName: BIPageName.MediaManager,
              target: Actions.DeleteForever,
              ...extractItemsBatchParams(items),
              ...extractCommonBiFieldsFromItems(item, { fileType }),
              ...params,
            }),
          );
        }, items);
      },
      trackEmptyTrash: (params: IParams) => {
        bi.logger().report(
          mediaManagerTrashActions({
            fileId: 'all',
            pageName: BIPageName.MediaManager,
            target: Actions.EmptyTrash,
            ...params,
          }),
        );
      },
    }),
    [fileType],
  );
};
